import { menuselect, getrouteparams } from "@/constant/menuselect";
let str = getrouteparams();
export const config = {
  title: "成本管理",
  headerInfo:
    "遵循成本核算原则，将医院成本核算的方法、流程、多维成本核算数据、成本分析报表等内容纳入到管理软件系统。实现从建立成本核算模型、成本数据采集、成本核算数据计算、成本数据存储、成本分析、成本数据应用到成本控制全过程管理。",
  headerImg: require("@/assets/images/cost/department/Rectangle19top.png"),
  activeTitle: str,
  activeSubTitle:str,
 
  navList: [
    {
      name: "成本管理",
      children: menuselect(),
    },

    {
      name: "科室成本管理",
      desc: "科室成本核算是指以科室为核算对象，按照一定流程和方法归集相关费用、计算科室成本的过程。敬在科室成本核算管理系统，支持自动采集医院相关业务系统（如HIS系统、物资供应链系统、资产设备管理系统、人力资源管理系统等业务系统）中的收入、成本、工作量数据，形成各科室的直接成本数据；也支持自动采集相关财务系统（如总账会计平台、全面预算管理系统等财务系统）中的凭证、预算等数据，作为各科室的直接成本数据。再本着相关性、成本效益关系及重要性等原则，采用阶梯分摊法，按照分项逐级分步结转的方式进行三级分摊，最终将所有成本分摊到临床服务类科室，形成各临床科室全成本。"+``+'敬在科室成本核算管理系统，满足最新的“公立医院成本核算规范”要求，支持以权责发生制为基础，以财务会计数据为准进行成本核算。核算结果能够及时的反应医院内部管理水平和运营效率；帮助准确评估科室经营状况及经济指标，通过分析科室成本构成，对影响成本的各种因素、条件施加影响或管控，将实际成本控制在预期目标内。进一步实现医院成本控制的目的，实现医院高质量发展的目标。',
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1104one1.png"),
        },
        {
          title: "核算方法：科室四类三级分摊",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1105one2.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/cost/department/Group 1105one3.png"),
        },
        {
          title: "支持打印各种类型的科室成本分析表",
          desc: " ",
          img: require("@/assets/images/cost/department/Group 1106one4.png"),
        },
        {
          title: "三大优势",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1095one5.png"),
        },
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/cost/department/Group 1108one6.png"),
        },
      ],
    },
    {
      name: "诊次/床日成本核算",
      desc: "诊次成本核算是指以诊次为核算对象，将科室成本进一步分摊到门急诊人次中，计算出诊次成本的过程。采用三级分摊后的临床门急诊科室总成本，计算出诊次成本。 床日成本核算是指以床日为核算对象，将科室成本进一步分摊到住院床日中，计算出床日成本的过程。采用三级分摊后的临床住院科室总成本，计算出床日成本。 敬在科室成本核算管理系统，支持个性化设置规则，将科室成本分摊到门诊住院科室，计算出门诊成本、住院成本，进而计算出相准确的诊次成本、床日成本数据。",
      tabList: [{}],
      [str]: [
        { title: "",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1109two1.png"),
        },
      ],
     
    },

    {
      name: "项目成本管理",
      desc:'医疗服务项目成本核算是指以各科室开展的医疗服务项目为对象，归集和分配各项费用，计算出各项目单位成本的过程。以临床服务类和医疗技术类科室二级分摊后成本剔除药品成本、单独收费的卫生材料成本作为医疗服务项目总成本，采用作业成本法、当量系数法、参数分配法等方法计算单个医疗服务项目成本。 敬在项目成本核算管理系统，不仅支持提供灵活的项目成本核算方法，还支持同时设置多套项目成本核算方案：可定义不同期间相同核算方法，对比不同期间相同方法下项目成本结果差异分析；也可定义相同期间不同核算方法（作业成本法或比例系数法），对比相同期间下不同核算方法项目成本结果差异分析。同时可以有效的支撑核算数据与业务数据的关联性和追溯性（正向、逆向追溯查询），提高医院成本核算工作效率。',
      tabList: [{}],
     [str]: [
        { title: "",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1110three1.png"),
        },
        { title: "支持打印各种类型的科室成本分析表",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1143three2.png"),
        },
        { title: "核算方法",
          desc: "满足最新“公立医院成本核算规范”中要求的作业成本法、当量系数法、参数分配法核算项目成本。",
          img: require("@/assets/images/cost/department/Frame 1116three3.png"),
        },
      ],
    },
    {
      name: "病种(DRG/DIP)成本管理",
      desc:'支持最新的“公立医院成本核算规范”的病种成本核算、DRG/DIP成本核算要求，支持如下核算对象及方法。',
      tabList: [{}],
      [str]: [
        { title: "",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1143four1.png"),
        },
        { title: "支持打印各种类型的科室成本分析表",
          desc: " ",
          img: require("@/assets/images/cost/department/Frame 1118four2.png"),
        },
        { title: "核算方法",
          desc: "建立病种成本和DRGS病组成本核算体系，建立适应 DRG支付的疾病组降本控费模式，采用参数分配法、项目叠加法、服务单元叠加法三种不同方法针对不同病种和DRGS病组完成病种、病组成本核算；对病人DRG病组成本、科室DRG成本、全院DRG成本进行计算、查询。在DRG成本核算基础上，提供DRG病组的构成分析、趋势分析、对比分析，控制分析为医院经营决策和管理提供数据依据；结合病种收益、成本构成、病种成本趋势、本量利、排名等方法进行病种成本分析；实现病种成本控制，指定单病种成本控制标准，对超标准病历进行异动提示。",
        },
      ],
    },
    {
      name: "DRG成本分析",
      desc:'DRG成本分析建立医疗行为事前、事中、事后的全面分析体系。基于全面分析的成本反馈调节体系，基于成本控制的资源调节过程管理。',
      tabList: [{}],
     [str]: [
        { title: "",
          desc: " ",
          img: require("@/assets/images/cost/department/Group 1119five1.png"),
        },
        { title: "",
          desc: "DRG下的医院运营分析",
          img: require("@/assets/images/cost/department/five2.png"),
        },
        { title: "",
          desc: "DRG下的科室运营分析",
          img: require("@/assets/images/cost/department/Rectanglefive3.png"),
        },
      ],
    },
  ],
};
